import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const WORKSHOP_KEY = "workshop_code";
const ADMIN_KEY = "admin_password";

export const getWorkshopCode = () => localStorage.getItem(WORKSHOP_KEY) || "";
export const setWorkshopCode = (code) => localStorage.setItem(WORKSHOP_KEY, code || "");
export const clearWorkshopCode = () => localStorage.removeItem(WORKSHOP_KEY);

export const getAdminPassword = () => localStorage.getItem(ADMIN_KEY) || "";
export const setAdminPassword = (pw) => localStorage.setItem(ADMIN_KEY, pw || "");
export const clearAdminPassword = () => localStorage.removeItem(ADMIN_KEY);

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const code = getWorkshopCode();
  if (code) config.headers["X-Workshop-Code"] = code;
  const adminPw = getAdminPassword();
  if (adminPw && (config.url || "").startsWith("/admin")) {
    config.headers["X-Admin-Password"] = adminPw;
  }
  return config;
});

export const fmtDate = (d) => {
  const x = new Date(d);
  const y = x.getFullYear();
  const m = String(x.getMonth() + 1).padStart(2, "0");
  const day = String(x.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
};

export const today = () => fmtDate(new Date());

export const addDays = (d, n) => {
  const x = new Date(d);
  x.setDate(x.getDate() + n);
  return x;
};

export const formatHours = (h) => {
  if (h == null) return "0h";
  const v = Number(h);
  if (Number.isInteger(v)) return `${v}h`;
  const s = v.toFixed(2).replace(/0+$/, "").replace(/\.$/, "");
  return `${s}h`;
};

const weekdayNames = ["Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado", "Domingo"];
export const weekdayName = (wd) => weekdayNames[wd] || "";

export const prettyDate = (iso) => {
  const [y, m, d] = iso.split("-");
  const dt = new Date(Number(y), Number(m) - 1, Number(d));
  const wd = (dt.getDay() + 6) % 7;
  return `${weekdayNames[wd]} ${d}/${m}`;
};

export const formatEuros = (cents) => {
  const v = (Number(cents) || 0) / 100;
  return v.toLocaleString("es-ES", { style: "currency", currency: "EUR" });
};

/**
 * Normalize FastAPI/axios error into a plain string message.
 */
export const errMsg = (e, fallback = "Error inesperado") => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" · ");
  if (d && typeof d.msg === "string") return d.msg;
  return e?.message || fallback;
};
